import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-virtual",
  "use": "icon-virtual-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-virtual\"><path d=\"M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0zm0 981.333C251.733 981.333 42.667 772.267 42.667 512S251.733 42.667 512 42.667 981.333 251.733 981.333 512 772.267 981.333 512 981.333z\" fill=\"#FFCA27\" /><path d=\"M529.067 738.133L512 793.6l-17.067-55.467-179.2-503.466h-102.4L473.6 917.333h76.8l260.267-682.666h-102.4z\" fill=\"#FFCA27\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol